import { render, staticRenderFns } from "./OrgElementComponentFunktionen.vue?vue&type=template&id=9863b7b6&lang=pug"
import script from "./OrgElementComponentFunktionen.vue?vue&type=script&lang=js"
export * from "./OrgElementComponentFunktionen.vue?vue&type=script&lang=js"
import style0 from "./OrgElementComponentFunktionen.vue?vue&type=style&index=0&id=9863b7b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports